export default __webpack_public_path__ + "static/media/cert-market-consumer.da6ec92a.jpg";